import api from '../../api'

export async function getDNSTierNews (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    mockData: 'company/news/dns-tier-news',
    url: '/news',
    params
  })
  return response.data
}

export async function getDNSNews (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    responseFormat: 'records',
    mockData: 'company/news/dns-news',
    url: `/news/company`,
    params
  })
  return response.data
}

export async function getDNSNewsStory (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    responseFormat: 'object',
    url: `/news/id`,
    params: params
  })
  return response.data
}

export async function getDNSNewsContent (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    responseFormat: 'data',
    mockData: 'company/news/dns-news-content',
    url: `/news/content/id`,
    params
  })
  return response.data
}

export async function getEdgarNews (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    responseFormat: 'records',
    mockData: 'company/news/edgar-news',
    url: `/news/company/external`,
    params
  })

  return response.data
}

export async function getEdgarNewsContent (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    responseFormat: 'data',
    mockData: 'company/news/edgar-news-content',
    url: `/news/content/id/external`,
    params
  })
  return response.data
}
